import { useMemo } from 'react';
import { Checkbox, MenuItem, Select, Typography, WithInfoIcon } from 'seagull';
import { getAllAutoApprovalDays, getAutoApprovalRange, isAutoApprovalValid } from "../../../business-logic/autoApprovalLogic";
import styles from "./ApprovalMethodNoticePeriodField.module.scss";
import pluralize from "../../../utils/pluralize";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function validateApprovalMethodNoticePeriod(enabled, noticePeriod) {
  return !enabled || !!noticePeriod && isAutoApprovalValid(noticePeriod);
}
export const ApprovalMethodNoticePeriodField = props => {
  const {
    info,
    text,
    testid,
    enabled,
    noticePeriod,
    isReadOnly,
    onToggle,
    onChangePeriod
  } = props;
  const {
    minDays,
    maxDays
  } = getAutoApprovalRange();
  const dayOptions = useMemo(() => getAllAutoApprovalDays().map(value => ({
    value,
    text: pluralize('day', value, true),
    testid: "".concat(testid, "-period-").concat(value)
  })), []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(WithInfoIcon, {
        info: info,
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: enabled,
          disabled: isReadOnly,
          onChange: e => onToggle(e.currentTarget.checked),
          "data-testid": "".concat(testid, "-toggle"),
          children: /*#__PURE__*/_jsx(Typography, {
            children: text
          })
        })
      })
    }), enabled && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.periodInput,
        children: /*#__PURE__*/_jsx(Select, {
          label: "Notice period",
          value: noticePeriod,
          disabled: isReadOnly,
          menuMaxHeight: 220,
          testid: "".concat(testid, "-period"),
          onChange: e => onChangePeriod(Number.parseInt(e.target.value)),
          children: dayOptions.map(_ref => {
            let {
              value,
              text,
              testid
            } = _ref;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: '' + value,
              "data-testid": testid,
              children: text
            }, value);
          })
        })
      }), !validateApprovalMethodNoticePeriod(enabled, noticePeriod) && /*#__PURE__*/_jsxs(Typography, {
        skin: "error",
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-error"),
        children: ["Notice period must be between ", minDays, " and ", maxDays, " days"]
      })]
    })]
  });
};